import api from "../api";

export const getAllCoursesByAdmin = async ({ page = 1, search = '' }) => {
   try {
    const response = await api.get('/course/get', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
  };

 export const getAllStaffManagement = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/staff/get', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

  export const accpetByAdmin = async (id) => {
    try {
      const response = await api.get(`/course/verify/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
    export const acceptUserByAdmin = async (id) => {
    try {
      const response = await api.get(`/staff/approve/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const deleteCourseByAdmin = async (courseId) => {
    try {
      const response = await api.delete(`/course/deleteByAdmin/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };
export const declineCourseByAdmin = async (courseId) => {
    try {
      const response = await api.delete(`/course/declineByAdmin/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };
    export const deleteUserByAdmin = async (courseId) => {
    try {
      const response = await api.delete(`/staff/decline/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

  export const declinePolicy = async (courseId) => {
    try {
      const response = await api.patch(`/policy/deactivate/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };
   export const acceptPolicy = async (courseId) => {
    try {
      const response = await api.patch(`/policy/approve/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

  
  export const getAllPolicies = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/policy/all', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

 export const getMyProfileData = async () => {
    try {
      const response = await api.get(`/auth/profile`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
  export const getAllSalesByAdmin = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/sales/admin', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};
 export const getMyDashboardData = async () => {
    try {
      const response = await api.get(`/admin/dashboard`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

   export const getAllTrainerManagement = async () => {
    try {
      const response = await api.get(`/trainer/all`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };


    export const addTrainerByAdmin = async (data) => {
    try {
      const response = await api.post('/trainer/add', data);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const acceptTrainerByAdmin = async (id) => {
    try {
      const response = await api.get(`/trainer/approve/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

    export const deleteTrainerByAdmin = async (courseId) => {
    try {
      const response = await api.delete(`/trainer/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

   export const declineTrainerByAdmin = async (courseId) => {
    try {
      const response = await api.delete(`/trainer/decline/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

  export const activeInactivePolicy = async (id) => {
    try {
      const response = await api.patch(`/policy/toogle/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${id}:`, error);
      throw error;
    }
  };


   export const downloadCsvFile = async () => {
    try {
      const response = await api.get(`/staff/export`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

   export const downloadCourseByAdmin = async () => {
    try {
      const response = await api.get(`/course/export`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
  export const downloadTrainerByAdmin = async () => {
    try {
      const response = await api.get(`/trainer/export`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

    export const downloadPolicyByAdmin = async () => {
    try {
      const response = await api.get(`/policy/export`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
